import { IListOptions, IColorKeys } from './lists.model';

export interface IAutocompleteOptions extends IListOptions {}

export class AutocompleteOptions implements IAutocompleteOptions {

    outputKey: string;

    labelKey: string;

    colorKeys: IColorKeys;

    styleOnlyAuto: boolean;

    constructor(options: IAutocompleteOptions) {

        this.outputKey = options.outputKey;
        this.labelKey = options.labelKey;
        this.colorKeys = options.colorKeys; 
        this.styleOnlyAuto = options.styleOnlyAuto;

        if (options.styleFn) {
            this.styleFn = (option): string => options.styleFn(option);
        }

        if (options.classFn) {
            this.classFn = (option): string => options.classFn(option);
        }
    }

    //To override
    styleFn = (option: any): string => {
        return '';
    }

    classFn = (option: any): string => {
        return '';
    }
}